import { IWorld } from "bitecs";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";

export class TinyPetsWorld implements IWorld {
    public time = {
        delta: 0,
        elapsed: 0,
        then: performance.now(),
    };

    public render = {
        models: {} as { [eid: number]: GLTF },
    };

    constructor() {
        this.time = {
            delta: 0,
            elapsed: 0,
            then: performance.now(),
        };
    }
}
